export default function effectInit(params) {
  const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective } = params;

  function doForEffect(func: () => void) {
    if (swiper.params.effect !== effect) {
      return;
    }
    func();
  }

  on("beforeInit", () => {
    doForEffect(() => {
      swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
      if (perspective && perspective()) {
        swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
      }

      const overwriteParamsResult = overwriteParams ? overwriteParams() : {};

      Object.assign(swiper.params, overwriteParamsResult);
      Object.assign(swiper.originalParams, overwriteParamsResult);
    });
  });

  on("setTranslate", (_s) => doForEffect(() => setTranslate()));

  on("setTransition", (_s, duration) => doForEffect(() => setTransition(duration)));

  on("transitionEnd", () => {});

  let requireUpdateOnVirtual: boolean;
  on("virtualUpdate", () => {
    doForEffect(() => {
      if (!swiper.slides.length) {
        requireUpdateOnVirtual = true;
      }
      requestAnimationFrame(() => {
        if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
          setTranslate();
          requireUpdateOnVirtual = false;
        }
      });
    });
  });
}
